import { useEffect } from "react";

const SRC = "https://cdnjs.buymeacoffee.com/1.0.0/widget.prod.min.js";
const ATTRS = {
  "data-name": "BMC-Widget", "data-cfasync": "false", "data-id": "doctorselvix", "data-description": "Support me on Buy me a coffee!",
  "data-message": "Offri un caffè a Doctor Selvix, per sostenerlo. ", "data-color": "#FF5F5F", "data-position": "Right", "data-x_margin": "18", "data-y_margin": "18",
};
const STYLE_ID = "bmc-hide-style";
let loaded = false;

const setVisible = (v) => {
  const s = document.getElementById(STYLE_ID);
  if (v) s?.remove();
  else if (!s) {
    const el = document.createElement("style");
    el.id = STYLE_ID;
    el.textContent = "#bmc-wbtn, #bmc-iframe, #bmc-wbtn + div { display: none !important; }";
    document.head.appendChild(el);
  }
};

const load = () => {
  loaded = true;
  const s = document.createElement("script");
  Object.entries(ATTRS).forEach(([k, v]) => s.setAttribute(k, v));
  s.src = SRC;
  s.async = true;
  // the widget initialises on DOMContentLoaded, which already fired in this SPA
  s.onload = () => {
    if (!document.getElementById("bmc-wbtn")) window.dispatchEvent(new Event("DOMContentLoaded"));
    document.querySelectorAll("#bmc-wbtn").forEach((n, i) => i > 0 && n.remove());
  };
  document.body.appendChild(s);
};

export function BuyMeACoffee() {
  useEffect(() => {
    setVisible(true);
    if (!loaded) load();
    return () => setVisible(false);
  }, []);
  return null;
}
